import { css } from '@emotion/css';

export const uploadClass = css`
  display: inline-flex;
  color: inherit;
  .ant-upload {
    display: inline-flex;
    color: inherit;
  }
`;
